var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0612 13.0613L17.0612 23.0613C16.9218 23.2011 16.7563 23.312 16.5739 23.3878C16.3916 23.4635 16.1961 23.5024 15.9987 23.5024C15.8013 23.5024 15.6058 23.4635 15.4235 23.3878C15.2411 23.312 15.0756 23.2011 14.9362 23.0613L4.9362 13.0613C4.6544 12.7795 4.49609 12.3973 4.49609 11.9988C4.49609 11.6002 4.6544 11.218 4.9362 10.9363C5.21799 10.6545 5.60018 10.4962 5.9987 10.4962C6.39721 10.4962 6.7794 10.6545 7.0612 10.9363L15.9999 19.875L24.9387 10.935C25.2205 10.6532 25.6027 10.4949 26.0012 10.4949C26.3997 10.4949 26.7819 10.6532 27.0637 10.935C27.3455 11.2168 27.5038 11.599 27.5038 11.9975C27.5038 12.396 27.3455 12.7782 27.0637 13.06L27.0612 13.0613Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDown);
export default __webpack_public_path__ + "static/media/expandDown.101860c23dc8850ead127412f5477f71.svg";
export { ForwardRef as ReactComponent };